import { DatePicker, Switch } from "antd";
import dayjs from "dayjs";
import { formatUTCTime } from "../../../global/utils/unixToLocalTime";
import {
  getOptionLabel,
  renderPrice,
  termOptions,
} from "../../../utils/Common";
const range = (start, end) =>
  Array.from({ length: Math.max(end - start, 0) }, (_, i) => start + i);

const disabledPastDate = (current) =>
  Boolean(current) && current.isBefore(dayjs(), "day");

const disabledPastTime = (current) => {
  const now = dayjs();
  if (!current || !current.isSame(now, "day")) return {};
  return {
    disabledHours: () => range(0, now.hour()),
    disabledMinutes: (hour) =>
      hour === now.hour() ? range(0, now.minute()) : [],
  };
};

export const PurchaseLicenseItemsColumns = ({
  showRenewal = false,
  editable = false,
  savingItemNo = null,
  onStartTimeChange,
  onRenewalChange,
} = {}) => {
  const columns = [
    {
      title: "Item",
      dataIndex: "ItemName",
      key: "ItemName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Code",
      dataIndex: "CodeName",
      key: "CodeName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Term",
      dataIndex: "Term",
      key: "Term",
      render: (value) => getOptionLabel(termOptions, value) || value || "",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: renderPrice,
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Start Time",
      dataIndex: "StartTime",
      key: "StartTime",
      width: editable ? 190 : undefined,
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (text, record) =>
        editable ? (
          <DatePicker
            size="small"
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            value={text ? dayjs(text) : null}
            allowClear={false}
            disabled={savingItemNo === record.ItemNo}
            disabledDate={disabledPastDate}
            disabledTime={disabledPastTime}
            onChange={(value) => value && onStartTimeChange?.(record, value)}
            style={{ width: "100%" }}
          />
        ) : (
          <div>{text ? formatUTCTime(text) : ""}</div>
        ),
    },
    {
      title: "End Time",
      dataIndex: "EndTime",
      key: "EndTime",
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
    },
  ];

  if (showRenewal) {
    columns.push({
      title: "Renewal",
      dataIndex: "Renewal",
      key: "Renewal",
      align: editable ? "center" : undefined,
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (value, record) => {
        if (!editable) return Number(value) === 1 ? "Yes" : "No";
        return (
          <Switch
            size="small"
            checked={Number(value) === 1}
            loading={savingItemNo === record.ItemNo}
            onChange={(checked) => onRenewalChange?.(record, checked)}
          />
        );
      },
    });
  }

  return columns;
};
